import React, { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const res = await api.get("/admin/auth/me");
      setAdmin(res.data);
    } catch (error) {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const res = await api.post("/admin/auth/login", { email, password });
    setAdmin(res.data.admin);
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post("/admin/auth/logout", {});
    } catch (error) {
      // Ignore errors on logout
    }
    setAdmin(null);
  };

  const hasPermission = (permission) => {
    if (!admin) return false;
    if (admin.role_id === "super_admin") return true;
    return admin.permissions?.includes(permission) || false;
  };

  const hasAnyPermission = (permissions) => {
    if (!admin) return false;
    if (admin.role_id === "super_admin") return true;
    return permissions.some((p) => admin.permissions?.includes(p));
  };

  return (
    <AdminAuthContext.Provider
      value={{
        admin,
        loading,
        login,
        logout,
        checkAuth,
        hasPermission,
        hasAnyPermission,
        isAuthenticated: !!admin,
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error("useAdminAuth must be used within AdminAuthProvider");
  }
  return context;
}
